import React from "react";
export default function NotFound() {
    return (
        <h1 className="text-center">
            <img src={require("./logo_studioexpress.jpg")} alt="logo" />
        </h1>
    );
}
